import React, { useState, useContext, useEffect } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Logo from "../assets/images/akra_logo.png";
import { useNavigate } from "react-router-dom";
import { store } from "../App";
import { useCookies } from "react-cookie";
import Cookies from "js-cookie";
import { Button } from "../components/Button/Button";


const baseURL = "https://ims.akrais.com:8444/PMSWEBAPI/api/auth/token";

const Login = () => {
  const [token, setToken, userId, setUserId] = useContext(store);
  const [isLoading, setIsLoading] = useState(false);
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [newResponse, setNewResponse] = useState<any>("");
  const [IsError, setIsError] = useState<any>()

  //const [] = useContext(store);
  const navigate = useNavigate();

  function handlebtnClick(){
    setIsBtnLoading(true)
  }

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(true);
    }, 1000);
  }, [setIsLoading, token]);

  useEffect(() => {
    if (Cookies.get("newJwt") && token) {
      const role = Cookies.get("roles");
      console.log(role)
      if (role && (role.includes("Admin") || role.includes("SuperAdmin"))) {
        return navigate("/selectclient");
      } else {
        Cookies.set("client", '1')
        return navigate("/portal/default");
      }
    } else {
      return navigate("/");
    }
    
    if(newResponse){
      setIsBtnLoading(false)
    }  
    if (newResponse && newResponse.response.status === 401) {
      console.log("invalid username password");
    }
  }, [navigate, newResponse, token]);


  function handleForgotPassword(){
    return navigate('/forgotpassword')
  }

  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .email("Email is invalid")
          .required("Email is required"),
        password: Yup.string()
          .min(6, "Password must be at least 6 characters")
          .required("Password is required"),
      })}
      onSubmit={(fields) => {
        axios
          .post(baseURL, {
            email: fields.email,
            password: fields.password,
          })
          .then((response) => {
            setToken(response.data.bearerToken);

            Cookies.set("newJwt", `${response.data.bearerToken}`, {
              expires: 7,
              path: "/",
            });
            Cookies.set("roles", `${response.data.roles}`, {
              expires: 7,
              path: "/",
            });

            setUserId({
              id: response.data.id,
              firstName: response.data.firstName,
              lastName: response.data.lastName,
              email: response.data.email,
            });
          })
          .catch((error) => {
            setNewResponse(error);
            console.log("error: " + error);
            setIsError(error)
          });
      }}
      render={({ errors, status, touched }) => (
        <>
          {isLoading ? (
            <main className="main h-100 w-100">
              <div className="container h-100">
                <div className="row h-100 mt-4">
                  <div className="col-sm-10 col-md-8 col-lg-5 mx-auto d-table h-100 mt-4">
                    <div className="d-table-cell align-middle mt-4">
                      <div className="text-center mt-4">
                        <h1 className="h2">Welcome</h1>
                        <p className="lead">
                          Sign in to your account to continue
                        </p>
                      </div>

                      <div className="card">
                        <div className="card-body">
                          <div className="m-sm-4">
                            <div className="text-center">
                              <img
                                src={Logo}
                                alt="Linda Miller"
                                className="img-fluid"
                                width="100"
                                height="100"
                              />
                            </div>
                            <Form>
                              <div className="mb-3">
                                <label htmlFor="email" className="text-body">
                                  Email
                                </label>
                                <Field
                                  name="email"
                                  type="text"
                                  className={
                                    "form-control form-control-lg" +
                                    (errors.email && touched.email
                                      ? " border border-danger"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="email"
                                  component="div"
                                  className="text-danger text-xs italic absolute"
                                />
                              </div>
                              <div className="mb-3">
                                <label htmlFor="password" className="text-body">
                                  Password
                                </label>
                                <Field
                                  name="password"
                                  type="password"
                                  className={
                                    "form-control form-control-lg" +
                                    (errors.password && touched.password
                                      ? " border border-danger"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="password"
                                  component="div"
                                  className="text-danger text-xs italic absolute"
                                />
                                <small>
                                  {/* <a href="pages-reset-password.html">
                                  Forgot password?
                                </a> */}
                                </small>
                              </div>
                              <div>
                                {newResponse &&
                                newResponse.response.status !== 400 ? (
                                  <span className="text-danger text-xs italic absolute">
                                    {IsError?.response?.data?.errors?.[0].message}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                              <div className="col-sm-12 text-end btn-link cursor-pointer" onClick={handleForgotPassword}>Forgot Password?</div>
                              <div className="text-center mt-3">
                                {/* <button
                                  type="submit"
                                  className="btn btn-lg btn-primary"
                                >
                                  Login
                                </button> */}
                                <Button
                                  type='submit'
                                  className="btn-primary"
                                  size="btn-lg"
                                  children='Login'
                                  showLoading={isBtnLoading}
                                  onClick={handlebtnClick}
                                />

                                {/* <!-- <button type="submit" className="btn btn-lg btn-primary">Sign in</button> --> */}
                              </div>
                            </Form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          ) : (
            <div className="splash active">
              <div className="splash-icon"></div>
            </div>
          )}
        </>
      )}
    />
  );
};

export { Login };
